package com.patronat.top.domain.usecase

import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.withContext

abstract class BaseUseCase<in IN, out OUT>(
    private val dispatcher: CoroutineDispatcher
) : UseCase<IN, OUT> {

    protected abstract suspend fun doWork(command: IN): OUT

    override suspend fun execute(command: IN): OUT {
        return withContext(dispatcher) {
            doWork(command)
        }
    }
}